import { startOfYear, endOfMonth } from 'date-fns';

import { SET_FILTER } from './constants';
import { Actions } from './actions';

export interface State {
  dateFrom: null | Date;
  dateTo: null | Date;
}

export const initialState = {
  dateFrom: startOfYear(new Date()),
  dateTo: endOfMonth(new Date()),
};

function givingAccountPageReducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case SET_FILTER:
      return { ...state, dateFrom: action.dateFrom, dateTo: action.dateTo };

    default:
      return state;
  }
}

export default givingAccountPageReducer;
